import type { I18nFn } from 'i18n/types/I18nFn';

export enum ProfessionalLevel {
  NONE = 'NONE',
  ENTRY_LEVEL = 'ENTRY_LEVEL',
  PROFESSIONAL = 'PROFESSIONAL',
  MANAGERIAL = 'MANAGERIAL',
  DIRECTOR = 'DIRECTOR',
  EXECUTIVE = 'EXECUTIVE',
}

export function PROFESSIONAL_LEVELS(i18n: I18nFn) {
  return {
    NONE: i18n('None specified'),
    ENTRY_LEVEL: i18n('Entry level'),
    PROFESSIONAL: i18n('Mid-level'),
    MANAGERIAL: i18n('Managerial'),
    DIRECTOR: i18n('Director'),
    EXECUTIVE: i18n('Executive'),
  };
}

export const PROFESSIONAL_LEVEL_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(PROFESSIONAL_LEVELS(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const PROFESSIONAL_LEVEL_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(PROFESSIONAL_LEVELS(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
